// extracted by mini-css-extract-plugin
export default {"link":"DemandeContactCard_link__lDTLB","loadingTitle":"DemandeContactCard_loadingTitle__AqOhz"};